import { flow, sortBy, take } from 'lodash/fp';

const filterHospitalServices = flow(sortBy('rank'), take(3));
export default filterHospitalServices;
